// Code generated by protoc-gen-zeroapi. DO NOT EDIT.

import service from '@/lobby_common/utils/request'

// 获取用户勋章列表
// Req : open_proto.client.v1.medal.GetMedalListReq
// Resp: open_proto.client.v1.medal.GetMedalListResp
export const getMedalList = (data) => {
  return service({
    url: '/v1/medal/getMedalList',
    method: 'post',
    data
  })
}
// 勋章兑换
// Req : open_proto.client.v1.medal.MedalExchangeReq
// Resp: open_proto.client.v1.medal.MedalExchangeResp
export const medalExchange = (data) => {
  return service({
    url: '/v1/medal/medalExchange',
    method: 'post',
    data
  })
}
// 勋章兑换列表
// Req : open_proto.common.Undefined
// Resp: open_proto.client.v1.medal.GetMedalExchangeListResp
export const getMedalExchangeList = (data) => {
  return service({
    url: '/v1/medal/getMedalExchangeList',
    method: 'post',
    data
  })
}
